import {
  LoginUrl,
  RegisterUrl,
  VerifyMobileUrl,
  OnboardingUrl,
  GetMeUrl,
  GetProductUrl,
  VeriyOTPUrl,
  ResetPasswordRequestUrl,
  SetNewPasswordUrl,
  SendOTPByPhoneUrl,
  SendOTPRequestOnboardingUrl,
  UpdateUserurl,
  LoginOtpUrl,
  benifitCheckWithPincodeUrl,
  SendOTPThroughExistingUserUrl,
  addUserThroughExistingCompanyUrl,
  SendOTPToChangePhoneNumberUrl,
  VerifyOTPToChangePhoneNumberUrl,
  VerifyToChangePhoneNumberOfCompanyOrUserUrl,
  GetMeUsingPhoneNumberUrl,
  DeleteAccountUrl,
  getOrderCostUrl,
  createOrderUrl,
  getSecondaryPermissionsUrl,
  getProductPriceVisibilityStatusUrl,
  getEditRequestsUrl,
  GetAllUserInsuranceCertificateUrl,
  getSalesDataOfAMonthAndYearUrl,
  GetAllIndustryManufacturersUrl,
  getSkuDetailsProductUrl,
  LogoutUrl,
} from '../api';
import { axios } from '../../../utils/settings';

export const LoginAction = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(LoginUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);
        //  dispatch({ type: 'HIDE_LOADER' })

        // return next(x)
      });
  });
};
export const logoutAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    console.log('gg', LogoutUrl);
    await axios
      .get(LogoutUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  });
};
export const LoginOtpAction = async (phone_number, otp) => {
  return new Promise(async (next) => {
    await axios
      .post(`${LoginOtpUrl()}?phone_number=${phone_number}&otp=${otp}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);
        //  dispatch({ type: 'HIDE_LOADER' })
        // return next(x)
      });
  });
};
export const ResetPasswordRequestNow = async (email) => {
  return new Promise(async (next) => {
    await axios
      .get(`${ResetPasswordRequestUrl()}/?email=${email}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        return next(error);
      });
  });
};
export const SetNewPassword = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(SetNewPasswordUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        return next(error);
      });
  });
};
export const RegisterNow = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(RegisterUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VerifyMobile = async (email_token) => {
  return new Promise(async (next) => {
    await axios
      .get(`${VerifyMobileUrl()}?email_token=${email_token}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VeriyOTPNow = async (userId, otp) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(
        `${VeriyOTPUrl()}?otp=${otp}&user_id=${userId}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

//For Onboarding Purposes
export const SendOTPRequestOnboardingNow = async (phone_number) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(
        `${SendOTPRequestOnboardingUrl()}?phone_number=${phone_number}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const SendOTPToChangePhoneNumber = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${SendOTPToChangePhoneNumberUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VerifyOTPToChangePhoneNumber = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${VerifyOTPToChangePhoneNumberUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VerifyToChangePhoneNumberOfCompanyOrUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${VerifyToChangePhoneNumberOfCompanyOrUserUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

//For Onboarding Purposes through existing user sending otp
export const SendOTPThroughExistingUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${SendOTPThroughExistingUserUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
//For Onboarding Purposes with data through existing user
export const addUserThroughExistingCompany = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${addUserThroughExistingCompanyUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
//For Reseting password
export const SendOTPByPhoneNow = async (phone_number) => {
  return new Promise(async (next) => {
    await axios
      .get(`${SendOTPByPhoneUrl()}?phone_number=${phone_number}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getSalesDataOfAMonthAndYear = async ({
  year,
  month,
  company_id,
}) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getSalesDataOfAMonthAndYearUrl()}?year=${year}&month=${month}&company_id=${company_id}`,
        {
          params: {},
          ...getTokenHeader(token),
        },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetAllUserInsuranceCertificate = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetAllUserInsuranceCertificateUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const DeleteAccount = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${DeleteAccountUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const OnboardingNow = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .post(OnboardingUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        // console.log(err);
        return err;
      });
  });
};
export const UpdateuserNow = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .put(UpdateUserurl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getEditRequestsAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(getEditRequestsUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  });
};
export const GetMeAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(GetMeUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  });
};
export const getSecondaryPermissionsAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(getSecondaryPermissionsUrl(), {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getProductPriceVisibilityStatusAction = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .post(
        getProductPriceVisibilityStatusUrl(),
        payload,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        // console.log(err);
        return err;
      });
  });
};

export const GetMeUsingPhoneNumber = async (phoneNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(GetMeUsingPhoneNumberUrl(phoneNumber), {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        // console.log(err);
        return err;
      });
  });
};
export const GetAllIndustryManufacturers = async (phoneNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(GetAllIndustryManufacturersUrl(), {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        // console.log(err);
        return err;
      });
  });
};

export const GetProducts = async (co_id, subProd, book_id) => {
  return new Promise(async (next) => {
    const token = await getToken();
    let axiosUrl = GetProductUrl();
    if (!subProd && !book_id)
      axiosUrl = `${GetProductUrl()}?company_id=${co_id}`;
    else if (book_id)
      axiosUrl = `${GetProductUrl()}?company_id=${co_id}&sub_product=${subProd}&order_booking_id=${book_id}`;
    else
      axiosUrl = `${GetProductUrl()}?company_id=${co_id}&sub_product=${subProd}`;
    await axios
      .get(axiosUrl, { ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        // console.log(err);
        return err;
      });
  });
};

export const createOrder = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${createOrderUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderCostAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${getOrderCostUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetProductsWithSkuDetails = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${getSkuDetailsProductUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getToken = async () => {
  return new Promise(async (next, error) => {
    try {
      // console.log("token is", await AsyncStorage.getItem('token'))
      next(await localStorage.getItem('token'));
    } catch (e) {
      next(null);
    }
  });
};
export const getIsFMCG = () => {
  return JSON.parse(localStorage.getItem('isFMCG'));
};
export const getTokenHeader = (token) => {
  return {
    headers: { Authorization: 'Bearer ' + token },
  };
};

export const getTokenHeaderFile = (token) => {
  return {
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'content-type': 'multipart/form-data;',
    },
  };
};

export const setPWAAction = (is_PWA) => (dispatch) => {
  dispatch({
    type: 'SET_IS_PWA',
    is_PWA,
  });
};
